// src/app/RequireAuth.tsx
import { useEffect, useState } from 'react'; // ✅ Add useState here
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getProfile } from '../lib/api';
import type { PropsWithChildren } from 'react';

export default function RequireAuth({ children }: PropsWithChildren) {
  const { isAuthenticated, token } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkPauseStatus = async () => {
      if (!isAuthenticated) {
        setChecking(false);
        return;
      }

      try {
        const authToken = token || localStorage.getItem('quiz_token');
        if (!authToken) {
          setChecking(false);
          return;
        }

        const profile = await getProfile(authToken);
        const isPaused = profile.has_used_pause && !profile.access_started_at;
        const isDashboard = location.pathname === '/app/dashboard';

        if (isPaused && !isDashboard) {
          // Redirect immediately — no need to store state
          navigate('/app/dashboard', { replace: true });
        }
      } catch (err) {
        console.error('Failed to check pause status:', err);
      } finally {
        setChecking(false);
      }
    };

    checkPauseStatus();
  }, [isAuthenticated, token, location.pathname, navigate]);

  if (!isAuthenticated) {
    return <Navigate to="/inloggen" state={{ from: location }} replace />;
  }

  if (checking) {
    return <div className="flex h-screen items-center justify-center">Bezig met laden...</div>;
  }

  return <>{children}</>;
}